(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      window.addEventListener('resize', this.setHeaderHeight, { passive: true });
      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      window.removeEventListener('resize', this.setHeaderHeight);
      this.headerResizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okhomes-jingle"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('okhomes-jingle')){
  customElements.define('okhomes-jingle',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.button=this.querySelector('button');
      this.label=this.querySelector('[data-jingle-label]');
      this.status=this.querySelector('[role="status"]');
      this.audio=new Audio();
      this.audio.preload='none';
      const signal=this.controller.signal;
      this.button.addEventListener('click',()=>{
        if(this.playing){this.stop();return;}
        this.status.textContent='';
        if(!this.audio.getAttribute('src'))this.audio.src=this.dataset.audioUrl;
        this.playing=true;
        this.update();
        this.audio.play().catch(()=>{this.stop();this.status.textContent=this.dataset.errorLabel;});
      },{signal});
      this.audio.addEventListener('ended',()=>this.stop(),{signal});
      this.audio.addEventListener('error',()=>{this.stop();this.status.textContent=this.dataset.errorLabel;},{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stop();},{signal});
      window.addEventListener('pagehide',()=>this.stop(),{signal});
      this.observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.stop();});
      this.observer.observe(this);
    }
    update(){
      this.button.setAttribute('aria-pressed',String(!!this.playing));
      this.label.textContent=this.playing?this.dataset.stopLabel:this.dataset.playLabel;
      this.button.querySelector('[aria-hidden]').textContent=this.playing?'■':'▶';
    }
    stop(){
      this.playing=false;
      this.audio.pause();
      if(this.audio.readyState)this.audio.currentTime=0;
      this.update();
    }
    disconnectedCallback(){
      if(!this.controller)return;
      this.stop();
      this.observer.disconnect();
      this.controller.abort();
      this.audio.removeAttribute('src');
      this.audio.load();
      this.controller=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okhomes-restailing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ok-rest]').forEach(root=>{
 const form=root.querySelector('form');
 const spaces=form.elements.spaces, painting=form.elements.painting, paintspaces=form.elements.paintspaces, fullhome=form.elements.fullhome, clean=form.elements.clean;
 const currency=n=>new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(n);
 const update=()=>{
  const count=Math.max(1,Math.min(50,Number(spaces.value)||1));
  if(paintspaces.options.length!==count){
   const selected=Math.max(1,Math.min(count,Number(paintspaces.value)||1));
   paintspaces.replaceChildren(...Array.from({length:count},(_,index)=>new Option(String(index+1),String(index+1))));
   paintspaces.value=String(selected);
  }
  const needsPaint=painting.checked||fullhome.checked;
  root.querySelector('[data-paint-details]').hidden=!painting.checked;
  paintspaces.disabled=!painting.checked;paintspaces.required=painting.checked;
  root.querySelector('[data-clean-details]').hidden=!needsPaint;
  clean.disabled=!needsPaint;clean.required=needsPaint;
  const painted=painting.checked?Math.max(1,Math.min(count,Number(paintspaces.value)||1)):0;
  form.querySelector('output').value=currency(count*500+painted*300);
 };
 form.addEventListener('input',update);form.addEventListener('change',update);
 form.addEventListener('submit',event=>{
  event.preventDefault();update();if(!form.reportValidity())return;
  const painted=painting.checked?Number(paintspaces.value):0;
  const lines=[root.dataset.message,form.elements.purpose.value,root.dataset.messageSpaces+spaces.value,root.dataset.messagePaint+painted];
  if(fullhome.checked)lines.push(root.dataset.messageHome);
  if(painting.checked||fullhome.checked)lines.push(root.dataset.messageClean);
  lines.push(root.dataset.messageTotal+form.querySelector('output').value,root.dataset.messageEnd);
  window.open('https://wa.me/34622238083?text='+encodeURIComponent(lines.join('\n')),'_blank','noopener,noreferrer');
 });
 update();
});

  } catch(e) { console.error(e); }
})();
})();
